module.exports = __webpack_public_path__ + "img/sha_01.cd9fc145.jpg";